<template lang="pug">
.reserve-page
  .main-title
    .person
      .person-fullName
        .firstName Hello {{ $root.member.user_name }}
        .lastName {{ $root.member.name }}
      .person-avatar
        img.user-pic(:src="$root.member.user_picture", alt="alt")
    p 歡迎預約
    .alculation-list
      .alculation-item
        //- .alculation-title.special-type
          |費用試算
        //- .alculation-content
          | NT$ ----
    .typesettin-unit
      .typesettin-item
        .unit-title
          |時間
        .unit-content
          | {{ $root.register.startTime }}
          br
          | {{ $root.register.endTime }}
      .typesettin-item(v-for="cartType in $root.register.carTypes")
        .row
          .col-6
            .unit-title
              | 租借種類
            .unit-content
              | {{ cartType.title }}
          .col-6
            .unit-title
              | 數量
            .unit-content
              | {{ cartType.amount }}
      .typesettin-item
        .unit-title
          | 租借時長
        .unit-content
          span(v-if="['hour', 'planA', 'planB'].indexOf($root.register.timeType) > -1") {{ $root.register.hours }} 小時
          span(v-if="$root.register.timeType === 'planC'") 1 天
          span(v-if="$root.register.timeType === 'day'") {{ $root.register.days }} 天
          span(v-if="$root.register.timeType === 'frequency'") 單次
  .button-group
    button.stepUp(type="button" @click="$router.go(-1)") 
      .step-txt 上一步
    button.stepNext.active(type="button" @click="goNext" ) 
      .step-txt 下一步
</template>

<script>
import Vue from "vue";
import { Calendar } from "vant";

Vue.use(Calendar);

export default {
  name: "reserve-page",
  components: {},
  data () {
    return {
    };
  },
  mounted () { },
  methods: {
    selectType (_type) {
      this.now_select = _type;
    },
    goNext () {
      this.$root.goPage('/reservation-notes')
    }
  },
};
</script>
<style lang="sass" scoped>
.reserve-page
  padding: 48px 35px 150px
  height: 100%
  overflow: auto
  .main-title
    .person
      display: flex
      justify-content: space-between
      align-items: center
      .person-fullName
        font-size: 32px
        font-weight: 700
        line-height: 2ex
        color: #fff
      .person-avatar
        width: 50px
        img
          width: 100%
          vertical-align: middle
    p
      font-size: 24px
      font-weight: 400
      color: #fff
      // padding-top: 13px
  .sub-title
    font-size: 18px
    font-weight: 700
    color: #898A8D
    padding-top: 34px
  .button-choose
    display: flex
    align-items: center
    gap: 12px
    padding: 7px
    border-radius: 10px
    background-color: #1E1E1E
    .stepHour,.stepDay,.frequency
      width: 160px
      border-radius: 5px
      border: none
      &.active
        background: #22F48F
        .step-txt
          color: #000
      .step-txt
        font-size: 18px
        font-weight: 700
        color: #898a8d
  .alculation-list
    display: flex
    justify-content: space-between
    margin-top: 34px
    .alculation-item
      .alculation-title
        font-size: 18px
        font-weight: 700
        color: #898A8D
      .alculation-content
        font-size: 32px
        color: #22F48F
      .special-type
        text-align: right
  .typesettin-unit
    .typesettin-item
      .unit-title
        font-size: 18px
        font-weight: 700
        color: #898A8D
        padding: 20px 0px
      .unit-content
        font-size: 32px
        color: #22F48F
        line-height: 2ex
  .button-group
    padding-top: 15%
    display: flex
    .stepNext,.stepUp
      width: 40vmin
      margin: auto
      border-radius: 12.5vmin
      background-color: #fff
      border: none
      padding: 3vmin 0px
      &.active
        background-color: #22F48F
      .step-txt
        text-align: center
        font-size: 6vmin
        font-weight: 700
        color: #1E1E1E
</style>
